import React, { useContext } from "react";
import { ModalContext } from "../context/ModalContext";
import ChangePasswordModal from "../components/user/ChangePasswordModal";
import UserInformation from "./UserInformation";
import UserAddress from "./UserAddress";
import { Link } from "@reach/router";
import { AuthContext } from "../context/AuthContext";

const MiInformacion = () => {
  const { modalComponent } = useContext(ModalContext);
  const { user } = useContext(AuthContext);

  const handleChangePassword = () => {
    modalComponent("Cambiar Contraseña", <ChangePasswordModal />);
  };

  const renderButton = () => {
    const completedAddress = user.address.street !== null;
    const completeInfo =
      user.birthdate !== null && user.last_name !== null && user.phone !== null;
    if (completedAddress && completeInfo) {
      return (
        <Link className="btn btn-sm bg-gradient-landing" to="/mytbm">
          Ir a Certificaciones <i className="fa fa-chevron-right ms-2" />
        </Link>
      );
    }
  };

  return (
    <div className="container py-4">
      <div className="row align-items-center mx-0 border-bottom pb-2 mb-3">
        <div className="col-6">
          <h1 className="h2 mb-0 mt-1">Mi Perfil</h1>
        </div>
        <div className="col-6 text-end">{renderButton()}</div>
      </div>
      <UserInformation />
      <UserAddress />
      <div className="card my-4 p-4 shadow">
        <h4 className="border-bottom pb-2">Seguridad</h4>
        <div>
          <button
            onClick={handleChangePassword}
            className="btn btn-sm mt-2 btn-primary"
          >
            <i className="fa fa-lock me-3"></i>Cambiar Contraseña
          </button>
        </div>
      </div>
    </div>
  );
};

export default MiInformacion;
